import React, { useState, useEffect } from "react";
import "./WParkHero.css";

import cityAerial from "../assets/hero_city.jpg";
import cambridge from "../assets/cjbs.png";
import microsoft from "../assets/microsoft.png";
import innovateUK from "../assets/innovateuk.png";
import hkstp from "../assets/HKSTP.png";
import Google from "../assets/googleforstartups.png";
import nvidia from "../assets/nvidia.png";

import WParkTrafficDemo from "./WParkTrafficDemo";

const SUPPORTERS = [
  {src: Google, name:"Google"},
  {src: nvidia, name:"Nvidia"},
  { src: innovateUK, name: "Innovate UK" },
  { src: cambridge, name: "University of Cambridge" },
  { src: microsoft, name: "Microsoft" },
  { src: hkstp, name: "HKSTP" },
];

const WParkHero = () => {
  const [showSpectre, setShowSpectre] = useState(false);
  const [playMusicTrigger, setPlayMusicTrigger] = useState(false);

  const revealSpectre = () => {
    setShowSpectre(true);
    setPlayMusicTrigger(true);
  };

  // ⭐ Expose the reveal function globally for SpectreButton → Card
  useEffect(() => {
    window.WPARK_REVEAL_SPECTRE_DEMO = () => {
      revealSpectre();
      const hero = document.getElementById("wpark-hero");
      if (hero) {
        hero.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
  }, []);

  return (
    <section id="wpark-hero" className="wphero">
      <div className="wphero__pulse"></div>

      <div className="wphero__inner">

        {/* LEFT */}
        <div className="wphero__left">
          <div className="wphero__brand">
          </div>

          <h1 className="wphero__title">An AI Powered Traffic Controller for Autonomous vehicles</h1>

          <p className="wphero__subtitle">
            Spatial intelligence that understands vehicles, space, and city flow.
          </p>

          <div className="wphero__actions">
            <a href="#how-it-works" className="wpbtn wpbtn--primary">See how it works</a>
            <a href="/waitlist" className="wpbtn wpbtn--ghost">Join Waitlist</a>
          </div>

          <div className="wphero__support">
            <span className="wphero__support-label">Supported by</span>
            <div className="wphero__support-logos">
              {SUPPORTERS.map((s) => (
                <div className="wphero__support-item" key={s.name}>
                  <img src={s.src} alt={s.name} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT — SPECTRE PREVIEW */}
        <div className="wphero__right">
          {!showSpectre && (
            <div className="spectrePreview" onClick={revealSpectre}>
              <img src={cityAerial} className="spectrePreview__img" alt="City" />

              {/* Large Play */}
              <div className="spectrePreview__centerPlay">
                <div className="spectrePreview__circlePulse"></div>
                <div className="spectrePreview__circlePulse2"></div>
                <div className="spectrePreview__bigPlay">▶</div>
              </div>

              <div className="spectrePreview__clickMe">
                <span className="spectrePreview__clickIcon">▶</span>
                <span>Click to Play</span>
              </div>

              <div className="spectrePreview__overlay">
                <h3>Spectre</h3>
                <p>AI Traffic Controller</p>
              </div>
            </div>
          )}

          {/* After Reveal */}
          {showSpectre && (
            <div className="spectreReveal fade-in">
              <WParkTrafficDemo autoplayMusic={playMusicTrigger} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WParkHero;
